<template>
  <div class="wrapper">
    <h2>
      Ustawienia zapisów:
    </h2>
    <el-card>
      <spinner>
        <el-form v-if="config">
          <el-form-item>
            <h3>Tytuł zapisów</h3>
            <el-input v-model="config.title" placeholder="Tytuł" />
          </el-form-item>
          <el-form-item>
            <h3>Link do zapisów</h3>
            <div class="registrationUrlContainer">
              <el-input v-model="linkPrefix" disabled />
              <el-input v-model="config.registrationsUrl" placeholder="Link" />
            </div>
          </el-form-item>
          <el-form-item>
            <h3>Tryb zapisów:</h3>
            <el-radio-group v-model="config.mode">
              <el-radio-button label="pokoje" />
              <el-radio-button label="domki" />
              <el-radio-button label="stoliki" />
              <el-radio-button label="autokary" />
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="button-container">
              <el-button type="success" :loading="isProcessing" @click="handleSubmit"
                >Zapisz
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div v-else>
          Problem z pobieraniem configiem.
        </div>
      </spinner>
    </el-card>
  </div>
</template>

<script>
import { SingleActions } from '@/shared/Actions'
import Spinner from '@/components/Spinner'
import { api } from '@/shared/api'

export default {
  name: 'RegistrationSettings',
  components: { Spinner },
  data: () => ({
    config: null,
    linkPrefix: 'zapisy.wydarzenia.napwr.pl/zapisy/',
    isConfigLoading: true
  }),
  computed: {
    isProcessing() {
      return this.$store.state.isProcessing[SingleActions.UPDATE_CONFIG]
    }
  },
  async mounted() {
    try {
      this.isConfigLoading = true
      const response = await api.config.getFull()
      this.config = response.data
    } catch (e) {
      this.isConfigLoading = false
    }
  },
  methods: {
    async handleSubmit() {
      await this.$store.dispatch(SingleActions.UPDATE_CONFIG, this.config)
      const response = await api.config.getFull()
      this.config = response.data
    }
  }
}
</script>

<style scoped lang="scss">
.registrationUrlContainer {
  display: flex;
}

.button-container {
  margin-top: 60px;

  & > button {
    width: 600px;
  }
}
</style>
